/**
 * @param checkbox {HTMLInputElement}
 * @return {void}
 */
module.exports = function updatePrivacyPolicyCheckboxValue(checkbox) {
    checkbox.value = checkbox.checked ? "true" : "NULL";
}